import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AncillaryAllBenefits } from '@app/pages/ancillary-bundle-page/ancillary-bundle.interfaces';

@Component({
  selector: 'ancillary-all-benefits',
  templateUrl: './ancillary-all-benefits.component.html',
  styleUrls: ['./ancillary-all-benefits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AncillaryAllBenefitsComponent {
  @Input() data: AncillaryAllBenefits;
  @Input() isBundleSelectActions: boolean;
  @Input() discountSize: number;

  @Output() close = new EventEmitter();
  @Output() continueWithoutBundle = new EventEmitter();
  @Output() continueWithBundle = new EventEmitter();
}
